export const CHAT_BOTSTATUS = 'chatBotStatus'
export const CHAT_GET_PERSONA = 'chatGetPersona'
export const CHAT_GET_PERSONA_IMAGE = 'chatGetPersonaImage'